import { useState, useEffect, useCallback } from "react";
import { Card, Table } from "antd";
import Box from "../components/Box";

import { rpcUrl, blockUrl } from "../utils/urls";

import axios from "../utils/axios";

import validatorList from "../validators.json";

const ValidatorTable = () => {
  const [validators, setValidators] = useState([]);
  const [validatorDetails, setValidatorDetails] = useState([]);

  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  const [blockHeight, setBlockHeight] = useState(null);

  const fetchValidators = useCallback(async (blockHeight, page, pageSize) => {
    const url = `${rpcUrl}/validators?height=${blockHeight}&page=${page}&per_page=${pageSize}`;

    axios
      .get(url)
      .then((response) => {
        if (response.data) {
          setValidators((prevState) => {
            return [...prevState, ...response.data.result.validators];
          });
          setTotal(response.data.result.total);
          setPage((prevState) => prevState + 1);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const getValidatorDetailFromAddress = (address) => {
    let detail = {};
    validatorDetails.forEach((validator) => {
      if (validator.address === address) {
        detail = validator;
      }
    });

    return detail;
  };

  const getTransformedDataSource = (validators) => {
    return validators
      .filter((value, index, self) => {
        return (
          self.findIndex((v) => {
            return v.address === value.address;
          }) === index
        );
      })
      .map((validator) => {
        const detail = getValidatorDetailFromAddress(validator.address);
        return {
          ...validator,
          ...detail,
        };
      })
      .sort((a, b) => b.voting_power - a.voting_power);
  };

  useEffect(() => {
    Object.keys(validatorList).forEach((key) => {
      const data = {
        ...validatorList[key],
        address: key,
      };

      setValidatorDetails((prevState) => {
        return [...prevState, data];
      });
    });
  }, []);

  const fetchLastBlock = useCallback(async () => {
    const url = `${blockUrl}/last`;

    axios.get(url).then((response) => {
      if (response.data) {
        setBlockHeight(response.data.last_commit.height);
      }
    });
  }, []);

  useEffect(() => {
    if (!blockHeight) {
      fetchLastBlock();
    }
  }, [blockHeight, fetchLastBlock]);

  useEffect(() => {
    if (blockHeight) {
      const pageSize = 100;
      if (page === 1) {
        fetchValidators(blockHeight, page, pageSize);
      } else if ((page - 1) * pageSize < total) {
        fetchValidators(blockHeight, page, pageSize);
      }
    }
  }, [fetchValidators, page, total, blockHeight]);

  const columns = [
    {
      title: "Moniker",
      render: (record) => {
        return <Box>{record?.alias ?? "N/A"}</Box>;
      },
    },
    {
      title: "Validator Address",
      render: (record) => {
        const shortHash = record?.address
          ? `${record.address.slice(0, 6)}...${record.address.slice(-6)}`
          : "N/A";
        return <Box>{shortHash}</Box>;
      },
    },
    {
      title: "Tendermint Address",
      render: (record) => {
        const shortHash = record?.nam_address
          ? `${record.nam_address.slice(0, 6)}...${record.nam_address.slice(-6)}`
          : "N/A";
        return <Box>{shortHash}</Box>;
      },
    },
    {
      title: "Voting Power",
      render: (record) => {
        const votingPower = record?.voting_power
          ? Intl.NumberFormat().format(record.voting_power / 1000000)
          : "N/A";
        return <Box>{votingPower}</Box>;
      },
    },
  ];
  return (
    <Box mt={16}>
      <Card>
        <h1>Validators</h1>
        <Table
          columns={columns}
          dataSource={getTransformedDataSource(validators)}
        />
      </Card>
    </Box>
  );
};

export default ValidatorTable;
